// package imports
import dvr from "mobx-react-form/lib/validators/DVR"
import vjf from "mobx-react-form/lib/validators/VJF"

import { Form } from "mobx-react-form"
import validatorjs from "validatorjs"

import moment from "moment"

// project imports
import FamilyDetailsStore from "../../../../family-details-form/store/FamilyDetailsStore"
import setInitialDefaults from "./initialDefaults"
import formObserver from "./observers"
import Utils from "./utils"
import * as keys from "./keys"

class ActivePensionPlusController extends Form {
  plugins() {
    return {
      dvr: dvr(validatorjs),
      vjf: vjf(),
    }
  }

  setup() {
    return {
      fields: [
        {
          name: "policy-term",
          label: "Policy Term",
          placeholder: "",
          value: '',
          extra: {
            optionList: [],
          },
        },
        {
          name: "premium-term",
          label: "Premium Paying Term",
          placeholder: "",
          disabled: true,
          extra: {
            optionList: [
              { label: "1", id: "1" },
              { label: "5", id: "5" },
              { label: "6", id: "6" },
              { label: "7", id: "7" },
              { label: "8", id: "8" },
              { label: "9", id: "9" },
              { label: "10", id: "10" },
            ],
          },
        },
        {
          name: "payment-frequency",
          label: "Premium Paying Frequency",
          placeholder: "Select",
          extra: {
            options: [
              { label: "Annual", id: "1" },
              { label: "Semi-Annual", id: "2" },
              { label: "Quarterly", id: "3" },
              { label: "Monthly", id: "4" },
            ],
          },
        },
        {
          name: "source-of-purchase-price",
          label: "Source Of Purchase Price",
          placeholder: "Select",
          extra: {
            options: [
              { label: "Open Market", id: "1" },
              // { label: "Proceeds of pension policy of ETLI Co Ltd", id: "2" },
              // { label: "Proceeds of pension policy of other Insurer", id: "3" },
              { label: "Proceeds of NPS (National Pension Scheme )", id: "4" },
            ],
          },
        },
        {
          name: "pran-number",
          label: "PRAN Number",
          value: "",
          extra: {
            onPranNoChange(e, form, data) {
              let pranNo = e.target.value;
              let regex = /^(([1-9]\d*))?$/;
              if (pranNo.length <= 12 && regex.test(pranNo)) {
                form.$('pran-number').value = pranNo
              }
            },
            onPranNoBlur(form, data) {
              let name = form.$('pran-number').value
              Utils.updateBi(keys.PRAN_NUMBER, name, data.data.package_id, form, data)
            },
            visible: true,
          },
        },
        {
          name: "annuity-benefit",
          label: "Annuity Benefit",
          placeholder: "Select",
          disabled: false,
          value: {},
          extra: {
            options: [
              // { label: "Immediate Annuity", id: "1" },
              { label: "Deferred Income", id: "2" },
            ],
            enableDefermentperiodAndChangeOptionList(optionValue, form, data) {
              form.$("annuity-benefit").value = optionValue

              if (form.$("annuity-benefit").value) {
                form.$("deferment-period").set("disabled", false)
              }
              // Utils.defermentPeiodOptionList(form, optionValue.id)

              // if (optionValue.id === "1") {
              //   form.$("deferment-period").set("value", { label: "NA", id: "10" })
              // } else {
              //   form.$("deferment-period").set("value", { label: "1", id: "11" })
              // }
            },
          },
        },
        {
          name: "life-status",
          label: "Life Status",
          placeholder: "Select",
          extra: {
            options: [
              { label: "Single Life", id: "3" },
              { label: "Joint Life", id: "4" },
            ],
          },
        },
        {
          name: "annuity-mode",
          label: "Annuity Mode",
          placeholder: "Select",
          extra: {
            options: [
              { label: "Yearly", id: "15" },
              { label: "Half-Yearly", id: "16" },
              { label: "Quarterly", id: "17" },
              { label: "Monthly", id: "18" },
            ],
          },
        },
        {
          name: "purchase-Price-amount",
          label: "Purchase Price Rs",
          type: "number",
          value: "",
          extra: {
            onPurchasePriceAmtChange(e, form, data) {
              let amt = e.target.value
              let regex = /^(([1-9]\d*))?$/;
              if (regex.test(amt)) {
                form.$('purchase-Price-amount').value = amt
              }
            },

            onPurchasePriceAmtBlur(form, data) {
              let name = form.$('purchase-Price-amount').value
              Utils.updateBi(keys.PURCHASE_PRICE, name, data.data.package_id, form, data)
            }
          }
        },
        {
          name: "deferment-period",
          disabled: false,
          label: "Deferment Period",
          placeholder: "Select",
          value: {},
          extra: {
            isVisible: true,
            options: [],
          },
        },
        {
          name: "annuity-option",
          label: "Annuity Option",
          placeholder: "Select",
          extra: {
            options: [

            ],
          },
        },
        {
          name: "secondary-annuitant-name",
          label: "Name of the Secondary Annuitant",
          value: "",
          disabled: false,
          extra: {
            onSecondaryAnnuitantNameChange(form, data) {
              let name = form.$('secondary-annuitant-name').value
              Utils.updateBi(keys.NAME_OF_THE_SECONDARY_ANNUITANT, name, data.data.package_id, form, data)
            }
          }
        },
        {
          name: "secondary-annuitant-date-of-birth",
          label: "DOB of the Secondary Annuitant",
          placeholder: "",
          disabled: false,
          extra: {
            changeDob(form, value, data) {
              form.$("secondary-annuitant-date-of-birth").set("value", value)
              let productId = data.data.package_id;
              const dateString = moment(value, "DD-MM-YYYY").format('LL')
              Utils.updateBi(keys.DOB_NAME_OF_THE_SECONDARY_ANNUITANT, dateString, productId, form, data)
            }
          },
        },
        {
          name: "secondary-annuitant-gender",
          label: "Gender of the Secondary Annuitant",
          placeholder: "Select",
          disabled: false,
          extra: {
            options: [
              { label: "Male", id: "13" },
              { label: "Female", id: "14" },
              // { label: "Transgender", id: "7" },
            ],
          },
        },
        // for death cover

        {
          name: "income",
          label: "Income",
          placeholder: "Income",
          value: "",
          extra: {
            calculateIncome(form, data) {
              let income = form.$("income").value
              Utils.updateBi(
                keys.INCOME,
                income,
                data.data.package_id,
                form,
                data
              )
            },
          },
          disabled: true,
        },
        {
          name: "premium-amt",
          label: "Premium",
          placeholder: "Premium",
          disabled: false,
          extra: {
            calculatePremium(form, value, data) {
              // Utils.updateBi(
              //   keys.PREMIUM,
              //   value,
              //   data.data.package_id,
              //   form,
              //   data
              // )

            },
          },
        },
        {
          name: "accrual-of-survival-benefit",
          label: "Accrual Of Survival Benefits",
          placeholder: "",
          disabled: false,
          extra: {
            optionList: [
              { label: 'No', id: 25 },
              { label: 'Yes', id: 24 }
            ],
            hide: false
          },
        },
        {
          name: "asb-start-age-(1st-opt-in)",
          label: "Start Age ( 1st Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 26)
          },

        },

        {
          name: "asb-end-age-(1st-opt-in)",
          label: "End Age ( 1st Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 127)
          },

        },
        {
          name: "withdrawal-parcentage-1",
          label: "WithDrawal Parcentage ( 1st Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForWithDrawalParcentage(0, 228)
          },

        },
        {
          name: "accrual-of-survival-benefits-year-2",
          label: "Accrual Of Survival Benefits Year 2",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [
              { label: 'Yes', id: 329 },
              { label: 'No', id: 330 }

            ],
            hide: false,
          },

        },

        {
          name: "asb-start-age-(2nd-opt-in)",
          label: "Start Age ( 2nd Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 331)
          },

        },

        {
          name: "asb-end-age-(2nd-opt-in)",
          label: "End Age ( 2nd Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 432)
          },

        },
        {
          name: "withdrawal-parcentage-2",
          label: "WithDrawal Parcentage ( 2st Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForWithDrawalParcentage(0, 533)
          },

        },
        {
          name: "accrual-of-survival-benefits-year-3",
          label: "Accrual Of Survival Benefits Year 3",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [
              { label: 'Yes', id: 634 },
              { label: 'No', id: 635 }

            ],
            hide: false
          },

        },

        {
          name: "asb-start-age-(3rd-opt-in)",
          label: "Start Age ( 3rd Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 636)
          },

        },

        {
          name: "asb-end-age-(3rd-opt-in)",
          label: "End Age ( 3rd Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForLP(0, 737)
          },

        },
        {
          name: "withdrawal-parcentage-3",
          label: "WithDrawal Parcentage ( 3st Opt In)",
          placeholder: "",
          disabled: false,
          value: "",
          extra: {
            optionList: [

            ],
            hide: false,
            preDefinedOptList: Utils.generatePredefinedOptListForWithDrawalParcentage(0, 838)
          },

        },
      ],
    }
  }

  setDefaults(data) {
    // Set forms initial default value
    setInitialDefaults(this, data.data)

    // Observer fields
    formObserver(this, data.data)
  }
}

export default ActivePensionPlusController
